import { useSubscriptionStore } from '@/stores/subscribe.js'
import { useClientStore } from '@shared/stores/client.js'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export function usePlans () {
  const subscriptionStore = useSubscriptionStore()
  const clientStore = useClientStore()
  const { membershipPlans, selectedPlanId, recommendedPlanId } = storeToRefs(subscriptionStore)
  const { plans } = storeToRefs(clientStore)
  const { fetchPlans, selectMembershipPlan } = subscriptionStore

  const fourItemPlan = computed(() => membershipPlans.value?.find(plan => plan.name === 'Armoire Capsule 4 Item'))
  const sevenItemPlan = computed(() => membershipPlans.value?.find(plan => plan.name === 'Armoire Monthly 7 Item'))
  const unlimitedPlan = computed(() => membershipPlans.value?.find(plan => plan.name === 'Armoire Unlimited Monthly'))

  function planById (planId) {
    if (!planId) return null
    
    const foundPlan = membershipPlans.value?.find(plan => plan?.id === planId)
    if (foundPlan) return foundPlan
    
    if (plans.value?.currentBasePlan?.id === planId) {
      return plans.value.currentBasePlan
    }
    
    return null
  }

  async function initializeMembershipPlans (forHomepage = false) {
    if (!membershipPlans.value) {
      await fetchPlans({ forHomepage })
    }
  }

  async function ensurePlanIsSelected () {
    await initializeMembershipPlans()
    if (!selectedPlanId.value) {
      selectedPlanId.value = recommendedPlanId.value
    }
  }

  const route = useRoute()
  const router = useRouter()
  async function setRoutePlanQuery (planId = selectedPlanId.value) {
    if (planId && route.query.plan !== planId) {
      await router.replace({ query: { ...route.query, plan: planId } })
    }
  }

  return {
    membershipPlans,
    selectedPlanId,
    fourItemPlan,
    sevenItemPlan,
    unlimitedPlan,
    planById,
    selectMembershipPlan,
    initializeMembershipPlans,
    ensurePlanIsSelected,
    setRoutePlanQuery
  }
}
